/**
 * Dashboard home translations: home (dashboard home page sections)
 */

export const home = {
  sectionAdmin: 'Administration',

  onboarding: {
    title: 'Start with your free namespace',
    subtitle: 'Perpetually free Kubernetes namespace',
    description:
      'You have no active services yet. Claim your free Kubernetes namespace and get going right away — or browse our products.',
    browseProducts: 'Browse products'
  },

  quickActions: {
    title: 'Quick Actions',
    newTicket: 'New Ticket',
    newTicketDesc: 'Request support',
    orderProduct: 'Order Product',
    orderProductDesc: 'Go to shop',
    domains: 'Domains',
    domainsDesc: 'Manage domains',
    products: 'Products',
    productsDesc: 'Manage products'
  },

  alerts: {
    title: 'Notifications',
    countOne: '{count} alert',
    countMany: '{count} alerts',
    unread: '{count} unread',
    noNew: 'No alerts',
    markAllRead: 'Mark all as read',
    allGood: 'All good',
    noNotifications: 'No notifications available',
    expiringSoonTitle: 'Expiring soon',
    expiringSoonMessage: '{name} expires in {days} day(s)',
    expiringSoonAction: 'View'
  },

  invoices: {
    title: 'Invoices',
    lastTransactions: 'Last {count} invoices',
    viewAll: 'View all',
    status: {
      paid: 'Paid',
      open: 'Open',
      void: 'Void',
      uncollectible: 'Unpaid'
    }
  },

  packets: {
    title: 'Packages',
    activePacket: '{count} active package',
    activePackets: '{count} active packages',
    manage: 'Manage',
    status: {
      active: 'Active',
      canceled: 'Cancelled',
      suspended: 'Suspended',
      inactive: 'Inactive'
    }
  },

  domainsCard: {
    title: 'Domains',
    registeredDomain: '{count} registered domain',
    registeredDomains: '{count} registered domains',
    manage: 'Manage',
    status: {
      active: 'Active',
      canceled: 'Cancelled',
      suspended: 'Suspended',
      inactive: 'Inactive'
    }
  },

  users: {
    title: 'User Management',
    subtitle: 'User accounts and permissions',
    total: 'Total',
    active: 'Active',
    verified: 'Verified',
    admins: 'Admins',
    resellers: 'Resellers',
    customers: 'Customers',
    manage: 'Manage'
  },

  productsCard: {
    title: 'Product Management',
    subtitle: 'Product and pricing configuration',
    products: 'Products',
    systemProducts: 'System products',
    active: 'Active',
    total: 'Total',
    manage: 'Manage'
  },

  revenue: {
    title: 'Revenue Overview',
    subtitle: 'Monthly statistics',
    comingSoon: 'Coming soon',
    description: 'Revenue statistics and trends will be displayed here.'
  },

  systemHealth: {
    title: 'System Status',
    subtitle: 'Servers and services',
    comingSoon: 'Coming soon',
    description: 'The status of all servers and services will be displayed here.',
    apiServer: 'API Server',
    database: 'Database',
    mailServer: 'Mail Server'
  },

  activity: {
    title: 'Activity Log',
    subtitle: 'Recent actions',
    comingSoon: 'Coming soon',
    description: 'Recent system activities will be displayed here.'
  }
} as const
